<template>
  <ElDialog
      name="branding-logo-modal"
      :visible="show"
      v-on="$listeners"
      v-loading="loading"
      :title="$t('branding.updateLogo')"
      @open="modalOpened"
      append-to-body
  >
    <VForm :onSubmit="validateForm" data-vv-scope="logo-update">
      <div slot="row">
        <p class="mb-none">{{ $t('branding.uploadLogoHelp') }}</p>
        <p>{{ $t('branding.logoHelp') }}</p>
        <TWFilePicker
          data-ec="branding_logo_modal"
          data-et="file_picker"
          @add="uploadLogo"
          accept="image/jpg, image/jpeg, image/png"
          data-hj-suppress
          :uploaderMessage="uploaderMessageText"
        />
        <b class="mt-base">{{ $t('functional.preview') }}</b>
        <div class="my-base p-sm brand-logo-display" v-bind:style="{ 'background-color': branding.colour ? branding.colour : '#0098CE' }">
          <div class="w-full h-full logo-bg" v-bind:style="`background: url('${logo}')`">
          </div>
        </div>
      </div>
      <div slot="formButtons">
        <VButton
            subtype="submit"
            class="float-right"
            data-ec="branding_logo_modal"
            data-et="save_button"
            type="cta-1">
          {{ $t('functional.save') }}
        </VButton>
      </div>
    </VForm>
  </ElDialog>
</template>
<script>

import VButton from '@/components/deprecated/atoms/Button.vue';
import TWFilePicker from '@/components/tailwind/FilePicker.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';

export default {
  name: 'BrandLogoModal',
  props: {
    show: Boolean,
    branding: Object,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      logo: null,
      loading: false,
      showResetModal: false,
      logoFile: null,
      logoHasChanged: false,
    };
  },
  components: {
    VForm,
    VButton,
    TWFilePicker,
  },
  computed: {
    uploaderMessageText() {
      return screen.width < 500 ? this.$t('functional.uploaderMessageMobile'): this.$t('functional.uploaderMessage'); // eslint-disable-line
    },
  },

  methods: {
    uploadLogo([file]) {
      this.logoFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logo = e.target.result;
      };
      reader.readAsDataURL(file);
      this.logoHasChanged = true;
    },
    modalOpened() {
      this.loading = true;
      this.logo = this.branding.logo;
      this.loading = false;
    },
    validateForm(scope) {
      if (!this.logoHasChanged) {
        this.$emit('close');
      } else {
        this.$validator.validateAll(scope).then((validated) => {
          if (validated) {
            this.loading = true;
            this.$store.dispatch('branding/UPDATE_FILE', { logo: this.logoFile }).then(() => {
              this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('branding.logoUpdatedMessage'), icon: 'check', type: 'success' }));
              this.loading = false;
              this.logoHasChanged = false;
              this.$emit('close');
            }).catch(() => {
              this.loading = false;
            });
          }
        });
      }
    },
  },
};
</script>
